import React from 'react';
import { useTranslation } from 'react-i18next';

const Request = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="py-0">
        <div className="container">
          {/* <h2 className="center p-1">
            Request a <span className="keywords">Form</span>
          </h2> */}
          <div className="bottom-line"></div>

          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <article className="card">
                <div>
                  <h3 className="mb-3 text-center">{t('Professional Form Completion Service')}</h3>
                  <p className="mb-3 text-center">
                    {t(
                      'Our healthcare providers can complete a wide variety of forms for work, school, insurance, and disability purposes. We review your medical history and provide accurate, professional documentation to meet your needs.'
                    )}
                  </p>

                  <div className="row">
                    <div className="col-md-6">
                      <h5>{t('✓ Quick Processing')}</h5>
                      <p>{t('Most forms completed within 1-2 business days')}</p>
                    </div>
                    <div className="col-md-6">
                      <h5>{t('✓ Professional Review')}</h5>
                      <p>{t('Thorough medical history assessment by healthcare providers')}</p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <h5>{t('✓ Secure Process')}</h5>
                      <p>{t('PIPA compliant and confidential handling of your information')}</p>
                    </div>
                    <div className="col-md-6">
                      <h5>{t('✓ No Appointment Required')}</h5>
                      <p>{t('Complete the process entirely online')}</p>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Request;
